<div class="container mb-1 tarifas100">
    <h5 class="title-step-2" align="center">
        <img src="./assets/img/package.svg" class="img-fluid ico-title" width="22"> Lista de tarifas
    </h5>

    <div *ngIf="rateMaster == null" class="mt-2 mb-5">
        <h5 align="center" class="tar-name-preload">Obteniendo tarifas...</h5>

        <div align="center">
            <img class="" src="./assets/img/spinner_rm.svg" width="30" alt="Cargando...">
        </div>
    </div>

    <div *ngIf="rateMaster != null">
        <h5 class="mb-3">
            <span class="me-3">Fibra y móvil</span> 
            <button class="btn btn-green btn-sm" [routerLink]="'/republica-movil/convergente'">
                Iniciar nueva contratación
            </button>
        </h5>

        <div class="alert alert-primary bg-black" role="alert">
            <h6 align="center" class="pt-2 pb-1" *ngIf="showOffer">
                <span class="pe-4 white" style="font-size: 19px;">+30Gb GRATIS para altas realizadas hasta el 31 de agosto</span>
                <a class="cursor-pointer" (click)="openModalOffer(modalOffer)">
                    <img src="./assets/img/info-white.svg" class="img-fluid ico-title" width="20">
                </a>
            </h6>
        </div>

        <div class="row">
            <ng-container *ngFor="let rate of rateMaster.ftth">
                <div class="col-lg-4" *ngFor="let mobileRate of rate.mobileRates">
                    <div class="card-tar card-white mb-4">
                        <div class="card-tar-header rm-verde">
                            <div class="d-flex justify-content-between align-items-center">
                                <h5 align="center" class="tar-name">
                                    <span>{{ rate.name }}</span>
                                    <br>
                                    <div style="text-align: left;">+ {{ mobileRate.name }}</div>
                                </h5>
                                <small class="text-muted">
                                    <h5 align="center" class="tar-name">
                                        {{ priceWithIVA(+rate.rateAmount + +mobileRate.rateAmount - +rate.discount).toFixed(0) }}
                                        <span class="eu2"> €/mes</span>
                                    </h5>
                                </small>
                            </div>
                        </div>

                        <div class="card-tar-body">
                            <ul class="mb-5">
                                <!-- info FTTH -->
                                <!-- <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelData">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    {{ rate.resumeLabelData }}
                                </h5> -->
                                <h5 align="left" class="tar-name-pricing" *ngIf="rate.labelData && rate.resumeLabelData == null">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    {{ rate.labelData }}
                                    <b *ngIf="rate.sublabelData">{{ rate.sublabelData }}</b>
                                </h5>
                                <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelVoice">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    <b> {{ rate.resumeLabelVoice }}</b>
                                </h5>

                                <!-- info Móvil -->
                                <!--<h5 align="left" class="tar-name-pricing">-->
                                <!--<img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15" style="visibility: hidden">-->
                                <!--+-->
                                <!--</h5>-->


                                <h5 align="left" class="tar-name-pricing" *ngIf="mobileRate.resumeLabelData">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    {{ mobileRate.resumeLabelData }}
                                </h5>
                                <h5 align="left" class="tar-name-pricing" *ngIf="mobileRate.labelData && mobileRate.resumeLabelData == null">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    {{ mobileRate.labelData }}
                                    <b *ngIf="mobileRate.sublabelData">{{ mobileRate.sublabelData }}</b>
                                </h5>
                                <h5 align="left" class="tar-name-pricing" *ngIf="mobileRate.resumeLabelVoice">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    {{ mobileRate.resumeLabelVoice }}
                                </h5>

                                <h5 align="left" class="tar-name-pricing" *ngIf="rate.discount > 0">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    <b> Te ahorras: {{ priceWithIVA(rate.discount).toFixed(0) }} <span class="eu2"> €/mes</span></b>
                                </h5>
                            </ul>

                            <ul class="mb-5">

                            </ul>
                            <div style="margin-top: -15px;">
                                <!--<button (click)="selectPack(rate, mobileRate)" class="btn btn-green btn-sm btn-block">Seleccionar</button>-->
                                <button class="btn btn-grey btn-sm btn-block" (click)="modalMoreInfo(rate, mobileRate)">Más info</button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <br><hr><br>

        <h5 class="mb-3">
            <span class="me-3">Solo Fibra</span> 
            <button class="btn btn-green btn-sm" [routerLink]="'/republica-movil/solo-fibra'">
                Iniciar nueva contratación
            </button>
        </h5>

        <div class="row">
            <ng-container *ngFor="let rate of rateMaster.ftth">
                <div class="col-lg-4">
                    <div class="card-tar card-white mb-4">
                        <div class="card-tar-header rm-verde">
                            <div class="d-flex justify-content-between align-items-center">
                                <h5 align="center" class="tar-name">
                                    <span>{{ rate.name }}</span>
                                </h5>
                                <small class="text-muted">
                                    <h5 align="center" class="tar-name">
                                        {{ priceWithIVA(+rate.rateAmount).toFixed(0) }}
                                        <span class="eu2"> €/mes</span>
                                    </h5>
                                </small>
                            </div>
                        </div>

                        <div class="card-tar-body">
                            <ul class="mb-5">
                                <!-- info FTTH -->
                                <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelData">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    {{ rate.resumeLabelData }}
                                </h5>
                                <h5 align="left" class="tar-name-pricing" *ngIf="rate.labelData && rate.resumeLabelData == null">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    {{ rate.labelData }}
                                    <b *ngIf="rate.sublabelData">{{ rate.sublabelData }}</b>
                                </h5>
                                <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelVoice">
                                    <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                    <b> {{ rate.resumeLabelVoice }}</b>
                                </h5>
                            </ul>

                            <ul class="mb-5">

                            </ul>
                            <div style="margin-top: -15px;">
                                <!--<button (click)="selectPack(rate, mobileRate)" class="btn btn-green btn-sm btn-block">Seleccionar</button>-->
                                <button class="btn btn-grey btn-sm btn-block" (click)="modalMoreInfo(rate)">Más info</button>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>

        <br><hr><br>

        <h5 class="mb-3">
            <span class="me-3">Prepago</span> 
            <button class="btn btn-green btn-sm" [routerLink]="'/republica-movil/solo-movil'">
                Iniciar nueva contratación
            </button>
        </h5>

        <div class="row">
            <div class="col-lg-4" *ngFor="let rate of prepaidRates">
                <div class="card-tar card-white mb-4">
                    <div class="card-tar-header rm-verde">
                        <div class="d-flex justify-content-between align-items-center">
                            <h5 align="center" class="tar-name">{{ rate.name }}</h5>
                            <small class="text-muted">
                                <h5 align="center" class="tar-name">
                                    {{ priceWithIVA(rate.rateAmount).toFixed(0) }}
                                    <span class="eu2"> €/mes</span>
                                </h5>
                            </small>
                        </div>
                    </div>

                    <div class="card-tar-body">
                        <ul class="mb-5">
                            <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelData">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                {{ rate.resumeLabelData }}
                            </h5>
                            <h5 align="left" class="tar-name-pricing" *ngIf="rate.labelData && rate.resumeLabelData == null">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                <span *ngIf="rate.packageId !== 'Pos_Micro'"> {{ rate.labelData }}</span>
                                <b *ngIf="rate.sublabelData">{{ rate.sublabelData }}</b>
                            </h5>

                            <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelVoice">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                <b *ngIf="rate.packageId !== 'Pos_Micro'"> {{ rate.resumeLabelVoice }}</b>
                            </h5>
                            <h5 align="left" class="tar-name-pricing">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                Sin permanencia
                            </h5>
                        </ul>
                        <div style="margin-top: -15px;">
                            <!--<button (click)="selectRate(rate)" class="btn btn-green btn-sm btn-block">Seleccionar</button>-->
                            <button class="btn btn-grey btn-sm btn-block" (click)="modalMoreInfo(rate)">Más info</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <br><hr><br>

        <h5 class="mb-3">
            <span class="me-3">Pospago</span> 
            <button class="btn btn-green btn-sm" [routerLink]="'/republica-movil/solo-movil'">
                Iniciar nueva contratación
            </button>
        </h5>

        <div class="alert alert-primary bg-black" role="alert" *ngIf="showOffer">
            <h6 align="center" class="pt-2 pb-1">
                <span class="pe-4 white" style="font-size: 19px;">+30Gb GRATIS para altas realizadas hasta el 31 de agosto</span>
                <a class="cursor-pointer" (click)="openModalOffer(modalOffer)">
                    <img src="./assets/img/info-white.svg" class="img-fluid ico-title" width="20">
                </a>
            </h6>
        </div>

        <div class="row">
            <div class="col-lg-4" *ngFor="let rate of postpaidRates">
                <div class="card-tar card-white mb-4">
                    <div class="card-tar-header rm-verde">
                        <div class="d-flex justify-content-between align-items-center">
                            <h5 align="center" class="tar-name">{{ rate.name }}</h5>
                            <small class="text-muted">
                                <h5 align="center" class="tar-name">
                                    {{ priceWithIVA(rate.rateAmount).toFixed(0) }}
                                    <span class="eu2"> €/mes</span>
                                </h5>
                            </small>
                        </div>
                    </div>

                    <div class="card-tar-body">
                        <ul class="mb-5">
                            <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelData">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                {{ rate.resumeLabelData }}
                            </h5>
                            <h5 align="left" class="tar-name-pricing" *ngIf="rate.labelData && rate.resumeLabelData == null">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                <span *ngIf="rate.packageId === 'Pos_Micro' && showOffer"> {{ rate.labelData }} + {{ rate.resumeLabelVoice }}</span>
                                <span *ngIf="rate.packageId !== 'Pos_Micro' || !showOffer"> {{ rate.labelData }}</span>                                <b *ngIf="rate.sublabelData">{{ rate.sublabelData }}</b>
                            </h5>

                            <h5 align="left" class="tar-name-pricing" *ngIf="rate.resumeLabelVoice">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                <b *ngIf="rate.packageId === 'Pos_Micro' && showOffer" style="color: #fa405c;"> Excluida de la promoción +30GB</b>
                                <b *ngIf="rate.packageId !== 'Pos_Micro' || !showOffer"> {{ rate.resumeLabelVoice }}</b>                            </h5>
                            <h5 align="left" class="tar-name-pricing">
                                <img src="./assets/img/check1.svg" class="img-fluid ico-title" width="15">
                                Sin permanencia
                            </h5>
                        </ul>
                        <div style="margin-top: -15px;">
                            <!--<button (click)="selectRate(rate)" class="btn btn-green btn-sm btn-block">Seleccionar</button>-->
                            <button class="btn btn-grey btn-sm btn-block" (click)="modalMoreInfo(rate)">Más info</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #modalOffer let-modal>
    <div class="modal-header">
        <h5 class="modal-title white" id="exampleModalLabel">Promoción +30GB</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">
                <img src="./assets/img/times2.svg" class="img-fluid ico-title" width="20">
            </span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row p-2">
            <div class="col-lg-12">
                <b>Promoción válida para altas/portabilidades móviles pospago hasta el 31 de agosto de 2020</b>
                <br>
                <span>Aplica a todas las líneas móviles pospago excepto las que contraten la tarifa cero</span>
                <br>
                <b>¿Cómo funciona?</b>
                <br>
                <span>Una vez que la línea del cliente esté activada el proceso es el siguiente:</span>
                <ul>
                    <li>Al día siguiente de la activación de su línea se le cargarán 10GB extras y se le enviará un SMS al cliente informándole.</li>
                    <li>Un mes después se le cargarán otros 10GB extras.</li>
                    <li>Un mes después se le cargarán otros 10GB extras.</li>
                    <li>Es decir, se distribuyen los 30GB gratis en 3 meses. Los GB que no haya consumido de un mes a otro se pierden.</li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>